<div class="scrollable">
    <app-cancernet-panel [drug]="explorerData.cancernetDrug" [(show)]="explorerData.showCancernetModal" (closeEvent)="explorerData.closeCancernetModal()"></app-cancernet-panel>
    <div class="content">
        <div class="container footer-padding">
            <div class="column is-8 is-offset-2">
                <div class="container has-text-centered">
                    <img src="assets/caddie_logo.png" alt="CADDIE logo" title="CADDIE logo" />
                    <h2 class="subtitle is-3"> Drug Interaction Lookup </h2>
                </div>
                <div class="content">
                    <br>
                    <div class="columns is-vcentered">
                        <div class="column">
                            <div class="field has-addons">
                                <div class="control">
                                    <input class="input" type="text" placeholder="DrugBank ID or name..." (keyup)="onKey($event)">
                                </div>
                                <div class="control">
                                    <button (click)="lookDrugUp(searchString, selectedInteractionDrugDataset)" class="button is-info" data-tooltip="Search for DrugBank ID for Drug name">
                    <span class="icon">
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </span> <span>Search</span>
                  </button>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <label class="has-text-right" data-tooltip="Select which daraset to use for gene-gene interactions">
                Interaction Dataset:
              </label>
                            <div class="field">
                                <app-interaction-dataset-tile [datasetItems]="interactionDrugDatasetItems" [selectedDataset]="selectedInteractionDrugDataset" (selectedDatasetChange)="selectedInteractionDrugDataset = $event;">
                                </app-interaction-dataset-tile>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="drug_lookup_result">
                <p-table *ngIf="searchResult != undefined && searchResult.drug.length > 0" [value]="searchResult.drug" dataKey="proteinAc">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>
                                DrugBank ID
                            </th>
                            <th>
                                Name
                            </th>
                            <th>
                                Approved
                            </th>
                            <th [pSortableColumn]="'isNutraceutical'">
                                Is Nutraceutical
                                <p-sortIcon [field]="'isNutraceutical'"></p-sortIcon>
                            </th>
                            <th [pSortableColumn]="'isATCAntineoplasticAndImmunomodulatingAgent'" class="has-tooltip" data-tooltip="ATC Class L (Antineoplastic or Immunomodulating Agents)">
                                Antineoplastic or Immunomod.
                                <p-sortIcon [field]="'isATCAntineoplasticAndImmunomodulatingAgent'"></p-sortIcon>
                            </th>
                            <th>
                                CanceRx
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-e>
                        <tr>
                            <td><a href="https://www.drugbank.ca/drugs/{{ e.dbId }}" target="_blank">{{ e.dbId }}</a></td>
                            <td>
                                {{e.name}}
                            </td>
                            <td>
                                <span *ngIf="e.status === 'approved'">
                    <i class="fa fa-check"></i>
                    Approved
                  </span>
                                <span *ngIf="e.status === 'unapproved'">
                    <i class="fa fa-times"></i>
                  </span>
                            </td>
                            <td>
                                <span *ngIf="e.isNutraceutical">
                    <i class="fa fa-leaf has-text-primary"></i>
                    Nutraceutical
                  </span>
                                <span *ngIf="!e.isNutraceutical">
                    <i class="fa fa-times"></i>
                  </span>
                            </td>
                            <td>
                                <span *ngIf="e.isAtcAntineoplasticAndImmunomodulatingAgent">
                    <i class="fa fa-check has-text-primary"></i>
                    Antineoplastic or Immunomodulating Agent
                  </span>
                                <span *ngIf="!e.isAtcAntineoplasticAndImmunomodulatingAgent">
                    <i class="fa fa-times"></i>
                  </span>
                            </td>
                            <td>
                                <span *ngIf="e.inCancernet">
                                    <a (click)="explorerData.openCancernetModal(e)" >open<i class="fa fa-external-link has-text-primary"></i></a>
                                  </span>
                                <span *ngIf="!e.inCancernet">
                    <i class="fa fa-times"></i>
                  </span>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>

                <br>
                <br>

                <div *ngIf="searchResult != undefined && searchResult.found" class="table-header">
                    <h4 class="is-4">
                        <span class="icon"><i class="fa fa-dna"></i></span>
                        <span>Genes ({{ searchResult.genes.length }})</span>
                    </h4>
                    <a [href]="downloadLink('csv')" class="download button is-primary is-outlined is-pulled-right is-small">
                        <span class="icon"><i class="fa fa-download"></i></span>
                        <span>Download</span>
                    </a>
                </div>
                <p-table *ngIf="searchResult != undefined && searchResult.genes.length > 0" [value]="searchResult.genes">
                    <ng-template pTemplate="header">
                        <tr>
                            <th [pSortableColumn]="'proteinAc'">
                                UniProt Code
                                <p-sortIcon [field]="'proteinAc'"></p-sortIcon>
                            </th>
                            <th [pSortableColumn]="'name'">
                                Gene
                                <p-sortIcon [field]="'name'"></p-sortIcon>
                            </th>
                            <th [pSortableColumn]="'proteinName'">
                                Protein Name
                                <p-sortIcon [field]="'proteinName'"></p-sortIcon>
                            </th>
                            <th [pSortableColumn]="'cancerTypes'">
                                Cancer Types
                                <p-sortIcon [field]="'cancerTypes'"></p-sortIcon>
                            </th>
                            <th [pSortableColumn]="'cancerDatasets'">
                                Cancer Datasets
                                <p-sortIcon [field]="'cancerDatasets'"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-e>
                        <tr [class.row-cancer-gene]="e.cancerTypes.length">
                            <td><a href="https://www.uniprot.org/uniprot/{{ e.gene.uniprotAc }}" target="_blank">{{ e.gene.uniprotAc }}</a></td>
                            <td>{{ e.gene.name }}</td>
                            <td>{{ e.gene.proteinName }}</td>
                            <td title="{{ previewStringArray(extractNames(e.cancerTypes), 100) }}">
                                {{previewStringArray(extractNames(e.cancerTypes), 3)}}
                            </td>
                            <td title="{{ previewStringArray(extractNames(e.cancerDatasets), 100) }}">
                                {{ previewStringArray(extractNames(e.cancerDatasets), 3) }}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>